import React from 'react';
import ProtectedRoute from '../../components/ProtectedRoute/ProtectedRoute';
import { AppStoreHomeProvider } from '../../features/apps/context/AppStoreHomeContext';
import AppStoreView from '../../features/apps/components/AppStoreView';

const AppStoreViewRoute = () => {
  return (
    <ProtectedRoute requiresAuth={true}>
      <AppStoreHomeProvider>
        <AppStoreView />
      </AppStoreHomeProvider>
    </ProtectedRoute>
  );
};

export default AppStoreViewRoute;
